import * as React from 'react';
import { observer } from 'mobx-react';
import { action, observable } from 'mobx';
import { Button, Panel, Well } from 'react-bootstrap';

import { ApiStore } from '../../stores/ApiStore';
import { bind, inject } from '../../utils/decorators';
import { UiStore } from '../../stores/UiStore';

interface IProtokollErzeugenProps {
  auftragId?: string;
  vorlage: string;
  vorgangId: string;
  text?: string;
  titel?: string;
  zeigeCaption?: boolean;
  onTriggerDocumentRefresh?: () => void;
}

@observer
export default class VorlageErzeugen extends React.Component<IProtokollErzeugenProps, {}> {

  @inject(ApiStore) apiStore: ApiStore;
  @inject(UiStore) uiStore: UiStore;

  @observable dokumentStatus: 'nichtVorhanden' | 'angefordert' | 'erzeugt' = 'nichtVorhanden';
  dokumentUrl: string | undefined;

  @bind @action setzeDokumentStatus(status: 'nichtVorhanden' | 'angefordert' | 'erzeugt') {
    this.dokumentStatus = status;
  }

  @bind async handleVorlageErzeugenClick() {
    this.setzeDokumentStatus('angefordert');
    const { auftragId, vorgangId, vorlage } = this.props;

    const response =
      (vorlage.indexOf('vermessung_kalibrierschein') > -1)  ?
      await this.apiStore.beurteilungaufstellflaecheKalibrierschein(vorgangId, auftragId) :
      await this.apiStore.vorgangVorlageErzeugen(vorgangId, vorlage);

    if (response.ok) {
      if (this.props.onTriggerDocumentRefresh) {
        this.props.onTriggerDocumentRefresh();
      }
      const downloadLink = await this.apiStore.vorgangDokumentDownloadUrl(vorgangId, response.json.detail.entryid as string);
      this.dokumentUrl = downloadLink;
      window.open(downloadLink);
      this.setzeDokumentStatus('erzeugt');
    }
  }

  render() {
    const caption = this.props.zeigeCaption ? this.props.zeigeCaption : false;
    return (
      <div>
        {caption && <h3><a name="#dokumente"/>Dokumente erzeugen</h3>}
        <Panel
          header={this.props.titel ? this.props.titel : 'Vorlage erzeugen'}
          bsStyle="success"
          footer={(
            <div className="text-right">
              <Button bsStyle="primary" onClick={this.handleVorlageErzeugenClick} disabled={this.dokumentStatus === 'angefordert'}>Vorlage erzeugen</Button>
            </div>
          )}
        >
          {(this.props.text == null) && <p>Erzeugt eine ausfüllbare Vorlage mit den zum Vorgang hinterlegten Daten. Diese muss nach dem Ausfüllen hochgeladen werden.</p>}
          {(this.props.text != null) && <div dangerouslySetInnerHTML={{__html: this.props.text}}/>}
          {this.dokumentStatus === 'angefordert' &&
            <Well bsSize="small" bsStyle="info">
              Dokument wird erzeugt...
            </Well>
          }
          {this.dokumentStatus === 'erzeugt' &&
            <Well bsSize="small" bsStyle="success">
              Die Vorlage wurde erzeugt, falls diese nicht in einem neuen Fenster geöffnet wurde, <a href={this.dokumentUrl} target="_blank">bitte hier klicken</a>.
            </Well>
          }
        </Panel>
      </div>
    );
  }

}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/vorlagen/VorlageErzeugen.tsx